import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface ScreenLevelSelectionState {
  segment: {
    brands: number[];
    markets: number[];
    segments: number[];
  };
  brand: {
    brands: number[];
    markets: number[];
    segments: number[];
  };
  market: {
    brands: number[];
    markets: number[];
    segments: number[];
  };
}

const initialState: ScreenLevelSelectionState = {
  segment: {
    brands: [],
    markets: [],
    segments: [],
  },
  brand: {
    brands: [],
    markets: [],
    segments: [],
  },
  market: {
    brands: [],
    markets: [],
    segments: [],
  },
};

interface UpdateFieldPayload {
  field: keyof ScreenLevelSelectionState;
  value: string | string[];
}

export const screenLevelSelectionSlice = createSlice({
  name: "screenLevelSelection",
  initialState,
  reducers: {
    updateScreenLevelSelection: (
      state: ScreenLevelSelectionState,
      action: PayloadAction<{
        screenType: keyof ScreenLevelSelectionState;
        value: Partial<ScreenLevelSelectionState[keyof ScreenLevelSelectionState]>;
      }>,
    ) => {
      const { screenType, value } = action.payload;
      Object.assign(state[screenType], value);
    },
    resetScreenLevelSelection: () => {
      return initialState;
    },
  },
});

export const { updateScreenLevelSelection, resetScreenLevelSelection } =
  screenLevelSelectionSlice.actions;

export default screenLevelSelectionSlice.reducer;
